import { render, staticRenderFns } from "./WorkspaceForm.vue?vue&type=template&id=74d5e7d0&"
import script from "./WorkspaceForm.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports